import { render, staticRenderFns } from "./MockQuestionPreview.vue?vue&type=template&id=7c5f69ce&scoped=true"
import script from "./MockQuestionPreview.vue?vue&type=script&lang=js"
export * from "./MockQuestionPreview.vue?vue&type=script&lang=js"
import style0 from "./MockQuestionPreview.vue?vue&type=style&index=0&id=7c5f69ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5f69ce",
  null
  
)

export default component.exports